var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrugCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7312 51.9707C41.4384 51.9707 52.5503 41.0017 52.5503 27.4707C52.5503 13.9397 41.4384 2.9707 27.7312 2.9707C14.024 2.9707 2.91211 13.9397 2.91211 27.4707C2.91211 41.0017 14.024 51.9707 27.7312 51.9707Z",
    stroke: "#797770",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrugCircle);
export default __webpack_public_path__ + "static/media/drug-circle.d956d74b6a5665676ecf2c00190bbba7.svg";
export { ForwardRef as ReactComponent };